import React, { useEffect } from 'react';
import { useToast } from '../contexts/ToastContext';

const AuthErrorHandler = ({ children }) => {
  const { showToast } = useToast();

  useEffect(() => {
    const handleForceLogout = (event) => {
      const { reason, status } = event.detail;
      showToast(
        `${reason} (${status}). You will be redirected to login.`, 
        'warning', 
        { duration: 3000 }
      );
    };

    window.addEventListener('forceLogout', handleForceLogout);
    
    return () => {
      window.removeEventListener('forceLogout', handleForceLogout);
    };
  }, [showToast]);

  return <>{children}</>;
};

export default AuthErrorHandler;